import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-gap-assist-cmb.component.scss';
var FormItemGapAssistCmb = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemGapAssistCmb, _super);
    function FormItemGapAssistCmb(element) {
        var _this = _super.call(this, element) || this;
        _this.gRecaptchaToken = '';
        return _this;
    }
    FormItemGapAssistCmb.prototype.init = function () {
        this.gapAssistCmbForm = this.element.querySelector('form');
        this.gapAssistCmbSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
        this.formLoader = this.element.querySelector(".form__loader--container");
        this.formThankyou = this.element.querySelector(".form__thankyou--container");
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
    };
    FormItemGapAssistCmb.prototype.bindEvents = function () {
        var _this = this;
        this.gapAssistCmbSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            var formFields = _this.gapAssistCmbForm.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_this.gapAssistCmbForm.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                // loader + hide form
                var fieldsContainer = _this.gapAssistCmbForm.querySelector('.form__fields--container');
                _this.formLoader.classList.add('active');
                fieldsContainer.classList.add('hidden');
                // Check if gRecaptcha is enabled for this form
                if (grecaptcha != null && _this.formsService.getGRecaptchaSiteKey() != '') {
                    var gToken_1 = '';
                    try {
                        // Attempt to get recaptcha token
                        grecaptcha.enterprise.ready(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var err_1;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, grecaptcha.enterprise.execute(this.formsService.getGRecaptchaSiteKey(), { action: 'LOGIN' })];
                                    case 1:
                                        gToken_1 = _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_1 = _a.sent();
                                        // Log error
                                        console.log("Unable to retrieve gRecaptcha Token");
                                        console.log(err_1);
                                        return [3 /*break*/, 3];
                                    case 3:
                                        // Set recaptcha token
                                        this.gRecaptchaToken = gToken_1;
                                        this.actionForm(this.gapAssistCmbForm);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                    catch (err) {
                        // Log error
                        console.log("Unable to retrieve gRecaptcha Token");
                        console.log(err);
                        _this.actionForm(_this.gapAssistCmbForm);
                    }
                }
                else {
                    _this.actionForm(_this.gapAssistCmbForm);
                }
            }
        }); });
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute('hidden', 'true');
                _this.showMoreBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute('hidden', 'true');
                _this.showLessBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupHideBtn) {
            this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
                _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingGroupShowBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupShowBtn) {
            this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute('hidden');
                _this.dataSharingGroupHideBtn.removeAttribute('hidden');
                _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyHideBtn) {
            this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
                _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyShowBtn) {
            this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharingBoardersShowBtn) {
            this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute('hidden');
                _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingBoardersHideBtn) {
            this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
            });
        }
    };
    FormItemGapAssistCmb.prototype.resetForm = function () {
        if (this.gapAssistCmbForm) {
            this.gapAssistCmbForm.reset();
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            formContainerThankyou.classList.remove('active');
            formContainerFields.classList.remove('hidden');
        }
    };
    FormItemGapAssistCmb.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemGapAssistCmb.prototype.actionForm = function (form) {
        var _this = this;
        // additional containers
        var success = form.querySelector('.form__success--container');
        var error = form.querySelector('.form__error--container');
        // fields
        var source = form.querySelector('input[name=source]');
        var suppliercampaign = form.querySelector('input[name=supplier-campaign]');
        var title = form.querySelector('.js-title');
        var firstname = form.querySelector('input[name=first-name]');
        var lastname = form.querySelector('input[name=last-name]');
        var contact = form.querySelector('input[name=phone-number]');
        var email = form.querySelector('input[name=email-address]');
        var popiaConsent = form.querySelector("input[name=popia-consent]");
        // loader + hide form
        var fieldsContainer = form.querySelector('.form__fields--container');
        this.formLoader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = '/leadsutils/createoneviewga';
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var _postData = {
            'source': (source ? source.value : ""),
            'supplierCampaign': (suppliercampaign ? suppliercampaign.value : ""),
            'title': (title ? title.value : ""),
            'firstName': (firstname ? firstname.value : ""),
            'lastName': (lastname ? lastname.value : ""),
            'contactNum': (contact ? contact.value : ''),
            'emailAdd': (email ? email.value : ''),
            'dataPrivacyConsent': (popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : 'NO'),
            'idNumber': '',
            'dataSharingWithinOurGrpMarketingConsent': this.getDataConsentValue(form, 'data-sharing-group'),
            'dataSharingWithThirdPartiesMarketingConsent': this.getDataConsentValue(form, 'data-sharing-3rd-party'),
            'dataSharingAcrossBordersWithinOurGrpMarketingConsent': this.getDataConsentValue(form, 'data-sharing-boarders'),
            'recaptchaToken': this.gRecaptchaToken
        };
        // service
        this.formsService.postForm(url, _postData, config).then(function (response) {
            _this.formLoader.classList.remove('active');
            if (response.data) {
                if (response.data.IsSuccess) {
                    analyticsService.dtmFormComplete('complete', response.code, false, "", email.value, contact.value);
                    _this.formThankyou.classList.add('active');
                    success.classList.add('active');
                    success.classList.remove('hidden');
                    error.classList.add('hidden');
                    error.classList.remove('active');
                }
                else if (response.data.captchaResponse != null && response.data.captchaResponse == false) {
                    analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
                    _this.formThankyou.classList.add('active');
                    error.classList.add('active');
                    error.classList.remove('hidden');
                    success.classList.add('hidden');
                    success.classList.remove('active');
                }
                else {
                    analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
                    _this.formThankyou.classList.add('active');
                    error.classList.add('active');
                    error.classList.remove('hidden');
                    success.classList.add('hidden');
                    success.classList.remove('active');
                }
            }
            else {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
                _this.formThankyou.classList.add('active');
                error.classList.add('active');
                error.classList.remove('hidden');
                success.classList.add('hidden');
                success.classList.remove('active');
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            this.formThankyou.classList.add('active');
            error.classList.add('active');
            error.classList.remove('hidden');
            success.classList.add('hidden');
            success.classList.remove('active');
        });
    };
    return FormItemGapAssistCmb;
}(Base));
export { FormItemGapAssistCmb };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-gap-assist-cmb/form-item-gap-assist-cmb.component.ts
// module id = 911
// module chunks = 0